import { Info, X } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Small inline banner shown at the top of a form when a saved draft was
 * restored from localStorage. Includes a "Discard draft" action.
 */
export function DraftRestoredBanner({ onDiscard, className = "" }) {
  return (
    <div
      className={`flex items-start gap-3 rounded-md border border-amber-200 bg-amber-50 dark:border-amber-800/60 dark:bg-amber-900/20 px-3 py-2 text-sm ${className}`}
      data-testid="draft-restored-banner"
    >
      <Info className="h-4 w-4 mt-0.5 text-amber-600 dark:text-amber-400 flex-shrink-0" />
      <div className="flex-1 text-amber-800 dark:text-amber-200">
        We restored your unsaved draft. Continue editing or discard to start
        fresh.
      </div>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={onDiscard}
        className="h-6 px-2 text-amber-700 dark:text-amber-300 hover:bg-amber-100 dark:hover:bg-amber-900/40"
        data-testid="draft-discard-btn"
      >
        <X className="h-3 w-3 mr-1" />
        Discard
      </Button>
    </div>
  );
}
